import React from 'react';
import { mui } from '@local/finsera-core/src/libs';

import { filterColumnsSx, finDataGridSx } from './styles';
import { SECTION_BG } from '../../theme/layout-size';

/**
 * A customized DataGrid component with consistent styling and fixed column menu icon alignment
 */
const FinDataGrid = ({
  sx,
  defaultBackgroundColor,
  initialState,
  ...props
}: mui.dataGrid.DataGridPremiumProps & { defaultBackgroundColor?: boolean }) => {
  const FilterPanel = () => (
    <mui.core.Box
      sx={{
        '.MuiDataGrid-panelContent': {
          padding: '0.5rem',
          maxWidth: '100%',
        },
        '.MuiDataGrid-filterForm': {
          alignItems: 'center',
          columnGap: 2,
          rowGap: 0,
          borderRadius: 4,
          mb: 3,
        },
        '.MuiInputBase-root': {
          marginTop: '0!important',
          background: SECTION_BG,
          borderRadius: '4px',
          overflow: 'hidden',
          '&:before': { display: 'none' },
        },
        '.MuiDataGrid-filterFormColumnInput': { width: '100px' },
        '.MuiDataGrid-filterFormOperatorInput': { width: '100px' },
        '.MuiDataGrid-filterFormValueInput': { width: '100px' },
      }}
    >
      <mui.dataGrid.GridFilterPanel />
    </mui.core.Box>
  );

  const Sx = React.useMemo(() => {
    let localStyles = finDataGridSx;
    // If column menu is enabled, apply the filter columns styles
    if (!props.disableColumnMenu) localStyles = { ...localStyles, ...filterColumnsSx };
    return { ...localStyles, ...(sx || {}) };
  }, [sx]);

  return (
    <mui.dataGrid.DataGridPremium
      sx={Sx}
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
        density: 'compact',
        ...(initialState || {}),
      }}
      slots={{
        filterPanel: FilterPanel,
      }}
      {...props}
    />
  );
};

export default FinDataGrid;
